import { useMemo } from 'react'

import { categoryIcons } from '../icons'
import type { QuickSearchPage, RecentActivityItem, SearchResult } from '../types'

type UseRecentActivityResultsParams = {
  recentItems: RecentActivityItem[] | null
  navigateAndClose: (href: string) => void
  pages: QuickSearchPage[]
}

/**
 * Converts recent activity items into SearchResult[] for display.
 * Returns null when there are no recent items.
 * For page items, enriches them with icons from the nav menu.
 */
export default function useRecentActivityResults({
  recentItems,
  navigateAndClose,
  pages
}: UseRecentActivityResultsParams): SearchResult[] | null {
  return useMemo(() => {
    if (!recentItems?.length) return null

    return recentItems.map((item) => {
      const matchingPage = item.category === 'page' ? pages.find((p) => p.href === item.path) : null
      const icon = matchingPage?.icon ?? categoryIcons[item.category]

      return {
        id: item.id,
        category: item.category,
        label: item.label,
        subLabel: item.subLabel,
        action: item.category === 'page' ? 'navigate' : 'view',
        icon,
        onSelect: () => navigateAndClose(item.path)
      }
    })
  }, [recentItems, navigateAndClose, pages])
}
